var _circle, _path, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.9 473.9",
    style: {
      enableBackground: "new 0 0 473.9 473.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "face-mask",
    className: "face has--mask",
    cx: 237,
    cy: 237,
    r: 237
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mask-slit",
    className: "mask-slit",
    d: "M418.5,161.1c0,0-96-71.1-185.8-71.1S49.3,161.1,49.3,161.1S244.5,290.2,418.5,161.1z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "eye-left",
    className: "eye mask--eye",
    cx: 164.9,
    cy: 155.2,
    r: 37.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "eye-right",
    className: "eye mask--eye",
    cx: 305.7,
    cy: 155.2,
    r: 37.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminSmiley);
export default __webpack_public_path__ + "static/media/admin-smiley.4c9a58e1.svg";
export { ForwardRef as ReactComponent };